import React from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { StyledH2 } from "@aureskonnect/react-ui";

import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";

const BUTTON_HEIGHT_PX = "48px";

export type ConfirmSaveModalProps = {
    isOpen: boolean;
    title: React.ReactNode;
    message: React.ReactNode;
    confirmLabel: string;
    cancelLabel: string;
    onConfirm: () => void;
    onCancel: () => void;
};

export function ConfirmSaveModal({
    isOpen,
    title,
    message,
    confirmLabel,
    cancelLabel,
    onConfirm,
    onCancel,
}: ConfirmSaveModalProps): JSX.Element {
    return (
        <Modal
            centered
            backdrop="static"
            fade={false}
            isOpen={isOpen}
            data-testid="printer-setting-confirm-modal"
        >
            <ModalHeader toggle={onCancel}>
                <StyledH2
                    className="text-uppercase"
                    data-testid="printer-setting-confirm-modal-title"
                >
                    {title}
                </StyledH2>
            </ModalHeader>
            <ModalBody data-testid="printer-setting-confirm-modal-body">
                {message}
            </ModalBody>
            <ModalFooter>
                <CustomSecondaryColorButton
                    outline
                    style={{ height: BUTTON_HEIGHT_PX }}
                    rounded
                    className="mr-2"
                    variant="light"
                    onClick={onCancel}
                    data-testid="printer-setting-confirm-modal-cancel-btn"
                >
                    <span>{cancelLabel}</span>
                </CustomSecondaryColorButton>
                <CustomMainColorButton
                    rounded
                    style={{ height: BUTTON_HEIGHT_PX }}
                    variant="primary"
                    onClick={onConfirm}
                    data-testid="printer-setting-confirm-modal-confirm-btn"
                >
                    {confirmLabel}
                </CustomMainColorButton>
            </ModalFooter>
        </Modal>
    );
}
